export default function CropsSection() {
  const commonCrops = [
    {
      name: "水稲",
      services: ["病害虫防除", "除草剤散布"],
      icon: "ri-plant-line",
      image: "https://public.readdy.ai/ai/img_res/89f69ebeb59a64265ea7067b78beef70.jpg"
    },
    {
      name: "麦",
      services: ["病害虫防除", "除草剤散布"],
      icon: "ri-plant-line",
      image: "https://readdy.ai/api/search-image?query=Golden%20wheat%20fields%20ready%20for%20harvest%2C%20healthy%20wheat%20crops%20swaying%20in%20breeze%2C%20agricultural%20drone%20applying%20treatments%20to%20wheat%20fields%2C%20modern%20farming%20techniques%2C%20grain%20crop%20protection%20services&width=400&height=300&seq=crop-wheat&orientation=landscape"
    },
    {
      name: "大豆",
      services: ["病害虫防除", "除草剤散布"],
      icon: "ri-plant-line",
      image: "https://readdy.ai/api/search-image?query=Healthy%20soybean%20plants%20in%20agricultural%20field%2C%20green%20soybean%20crops%20growing%20in%20rows%2C%20drone%20spraying%20services%20for%20soybean%20protection%2C%20sustainable%20legume%20farming%2C%20precision%20agriculture%20for%20soybeans&width=400&height=300&seq=crop-soybean&orientation=landscape"
    }
  ];

  const otherCrops = [
    { name: "野菜", service: "各種病害虫防除" },
    { name: "果樹", service: "農薬散布（初回測量が必要）" },
    { name: "遮熱・遮光剤塗布", service: "鹿児島拠点のみ" }
  ];

  const otherServices = [
    { name: "ドローン測量サービス", description: "農業用自動航行MAP作成" },
    { name: "ドローン運搬サービス", description: "林業・建設現場での資材運搬（佐賀拠点のみ）" }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            対応品目
          </h2>
          <div className="w-24 h-1 bg-[#4CAF50] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            水稲、麦、大豆をはじめ、様々な作物に対応しています。<br />
            拠点により対応品目が異なりますので、詳細はお問い合わせください。
          </p>
        </div>

        {/* 共通対応品目 */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">共通対応品目</h3>
          <div className="grid md:grid-cols-3 gap-8">
            {commonCrops.map((crop, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={crop.image}
                  alt={crop.name}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-[#4CAF50] text-white rounded-full flex items-center justify-center mr-3">
                      <i className={`${crop.icon} text-xl`}></i>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900">{crop.name}</h4>
                  </div>
                  <ul className="space-y-2">
                    {crop.services.map((service, serviceIndex) => (
                      <li key={serviceIndex} className="flex items-center text-gray-700">
                        <i className="ri-check-line text-[#4CAF50] mr-2"></i>
                        {service}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* その他対応品目 */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">その他対応品目（拠点により異なります）</h3>
          <div className="grid md:grid-cols-3 gap-6">
            {otherCrops.map((crop, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 text-center">
                <h4 className="text-lg font-bold text-gray-900 mb-2">{crop.name}</h4>
                <p className="text-gray-600">{crop.service}</p>
              </div>
            ))}
          </div>
        </div>

        {/* その他サービス */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">その他サービス</h3>
          <div className="grid md:grid-cols-2 gap-6">
            {otherServices.map((service, index) => (
              <div key={index} className="bg-[#4CAF50]/5 border border-[#4CAF50]/20 rounded-xl p-6">
                <h4 className="text-lg font-bold text-gray-900 mb-2">{service.name}</h4>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 注意事項 */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6">
          <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
            <i className="ri-information-line text-yellow-600 mr-2"></i>
            ご利用にあたっての注意事項
          </h4>
          <ul className="space-y-2 text-gray-700">
            <li className="flex items-start">
              <i className="ri-arrow-right-s-line text-yellow-600 mr-2 mt-1 flex-shrink-0"></i>
              料金は拠点により異なります。詳細は各拠点ページをご確認ください。
            </li>
            <li className="flex items-start">
              <i className="ri-arrow-right-s-line text-yellow-600 mr-2 mt-1 flex-shrink-0"></i>
              散布は1haからのご依頼となります。1ha未満の場合は1ha分の料金が発生する場合がございます。
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}